package com.essntl.features.message.ui.chat

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.stringToEpochSeconds
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.uikit.components.chat.contact.ContactUiState
import com.essntl.uikit.components.chat.message.MessageUiState
import com.essntl.uikit.rememberFind

@Composable
fun ChatState.rememberClient(phoneNumber: String?) =
    rememberFind(
        getClients.data.orEmpty(),
        phoneNumber,
    ) { client -> client.telephone }

@Composable
fun ChatState.rememberMessagesUiState() =
    remember(
        getAllWhapiMessages,
        getAllMessages,
        getClients,
        getAllWhapiCalls,
    ) {
        val messages = getAllWhapiMessages.data.orEmpty()
            .filter {
                it.type == WhapiMessageModel.Type.Text ||
                    it.type == WhapiMessageModel.Type.Image ||
                    it.type == WhapiMessageModel.Type.Voice ||
                    it.type == WhapiMessageModel.Type.LinkPreview
            }
            .map { whapiMessage ->
                val sender = getAllMessages.data.orEmpty().firstOrNull { it.platformId == whapiMessage.id }
                val actions = getAllWhapiMessages.data.orEmpty().filter { it.type == WhapiMessageModel.Type.Action }
                val reaction = actions.filter { it.action != null && it.action?.target == whapiMessage.id }
                val client =
                    getClients.data.orEmpty().firstOrNull { it.telephone == whapiMessage.from }

                whapiMessage.toUiState(
                    senderName = sender?.sender?.prettyName,
                    reactions = reaction,
                    contact = ContactUiState(
                        name = client?.prettyName ?: whapiMessage.fromName,
                        phoneNumber = whapiMessage.from,
                        isOnline = false,
                        type = null,
                    ),
                )
            }

        val calls = getAllWhapiCalls.data.orEmpty()
            .map {
                MessageUiState.empty.copy(
                    text = it.body,
                    contact = ContactUiState.empty.copy(name = it.title),
                    type = MessageUiState.Type.Call,
                    dateTime = stringToEpochSeconds(it.createdAt).toString(),
                )
            }
            .toSet()

        (messages + calls)
            .sortedWith(
                compareByDescending { it.dateTime },
            )
    }

@Composable
fun ChatState.rememberGroupParticipants(): List<String> =
    remember(
        getClients,
        getAllSupplier,
        getAllTravelAgent,
        getWhapiChat,
    ) {
        getWhapiChat.data?.participants.orEmpty().mapNotNull { participant ->
            val client = getClients.data.orEmpty().firstOrNull { it.telephone == participant.id }
            val supplier = getAllSupplier.data.orEmpty().firstOrNull { it.contact?.phoneNumber == participant.id }
            val travelAgent = getAllTravelAgent.data.orEmpty().firstOrNull { it.contact?.phoneNumber == participant.id }

            client?.prettyName ?: supplier?.contactName ?: travelAgent?.prettyName
        }
    }